import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import { ISubscription } from 'rxjs/Subscription';

import Handsontable from 'handsontable';
import { HotRegisterer } from 'angular-handsontable';
import {Report} from '../shared/report.model';
import {ReportDataService} from '../report-data.service';

@Component({
  selector: 'app-unit-or-sublot-allocation-components',
  templateUrl: './unit-or-sublot-allocation-components.component.html',
  styleUrls: ['./unit-or-sublot-allocation-components.component.css']
})
export class UnitOrSublotAllocationComponentsComponent implements OnInit, OnDestroy {
  columns: Array<Object>;
  report: Report;
  data: any;
  reloadSubscription: ISubscription;

  constructor(private reportService: ReportDataService, private gridContext: HotRegisterer) {
  }

  ngOnInit() {
    this.report = this.reportService.getReport();
    this.columns = this.report.UnitOrSublotAllocationComponents.columns;
    this.data = this.report.UnitOrSublotAllocationComponents.data;
    this.reloadSubscription = this.reportService.getReload().subscribe(data => this.reload());
  }

  ngOnDestroy() {
    this.reloadSubscription.unsubscribe();
  }

  reload() {
    this.data = this.report.UnitOrSublotAllocationComponents.data;
    const gridInstance = this.gridContext.getInstance('UnitOrSublotAllocationComponents');
    gridInstance.loadData(this.data);
  }
}


// WEBPACK FOOTER //
// ./src/app/unit-or-sublot-allocation-components/unit-or-sublot-allocation-components.component.ts